import React from 'react';
import {TransformComponent, TransformWrapper} from "react-zoom-pan-pinch";
import {Card} from "../../../../components/card/card.jsx";
import clsx from "clsx";
const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const CloneModalPassageCard = ({info, title, attach}) => {
    return (
        <div className={`col-span-5`}>
            <Card className="h-130 flex flex-col">
                <Card.Header>
                    <h4 className="w-full text-center m-1">{title}</h4>
                </Card.Header>
                <Card.Body className="grow overflow-hidden">
                    <div className={clsx("flex flex-col items-center w-full h-full", info ? "justify-start" : "justify-center")}>
                        <TransformWrapper key={attach}>
                            <TransformComponent
                                wrapperStyle={{width: "100%", flexShrink: 0}}
                                contentStyle={{width: "100%"}}
                            >
                                <img
                                    className={clsx("w-full object-contain rounded-[0.2em]", info ? "h-87.5" : "max-w-[90%] mx-auto")}
                                    src={`${API_KEEPER}/ged/attach/${attach}`}
                                    alt={attach}
                                />
                            </TransformComponent>
                        </TransformWrapper>

                        {
                            info &&
                            <div className="mt-3 w-full p-3 rounded text-sm grow overflow-y-auto">
                                <p className="mb-1">
                                    Corporação: <span className="mb-[0.1rem]"><b>{info?.entityName || "Sem informações"}</b></span>
                                </p>
                                <p className="mb-1">
                                    Endereço da câmera: <span className="mb-[0.1rem]"><b>{info?.laneAddressFormatted || "Sem informações"}</b></span>
                                </p>
                                <p>
                                    Data/hora da passagem: <span className="mb-[0.1rem]"><b>{info?.captureTime || "Sem informações"}</b></span>
                                </p>
                            </div>
                        }
                    </div>
                </Card.Body>
            </Card>
        </div>
    );
};

export default CloneModalPassageCard;


